// source: billing-publisher.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var google_protobuf_struct_pb = require('google-protobuf/google/protobuf/struct_pb.js');
goog.object.extend(proto, google_protobuf_struct_pb);
var common_pb = require('./common_pb.js');
goog.object.extend(proto, common_pb);
goog.exportSymbol('proto.concierge_billing_publisher.BillingConciergeDiscountRequest', null, global);
goog.exportSymbol('proto.concierge_billing_publisher.BillingConciergePriceRangeResponse', null, global);
goog.exportSymbol('proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem', null, global);
goog.exportSymbol('proto.concierge_billing_publisher.BillingPublisherAddress', null, global);
goog.exportSymbol('proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings', null, global);
goog.exportSymbol('proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings', null, global);
goog.exportSymbol('proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings', null, global);
goog.exportSymbol('proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings', null, global);
goog.exportSymbol('proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewRequest', null, global);
goog.exportSymbol('proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewResponse', null, global);
goog.exportSymbol('proto.concierge_billing_publisher.BillingPublisherPayoutRemovingRequest', null, global);
goog.exportSymbol('proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest', null, global);
goog.exportSymbol('proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsResponse', null, global);
goog.exportSymbol('proto.concierge_billing_publisher.BillingPublisherPayoutSettings', null, global);
goog.exportSymbol('proto.concierge_billing_publisher.BillingPublisherPayoutSettings.SettingsCase', null, global);
goog.exportSymbol('proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse', null, global);
goog.exportSymbol('proto.concierge_billing_publisher.BillingPublisherPayoutVerificationRequest', null, global);
goog.exportSymbol('proto.concierge_billing_publisher.BillingPublisherResponse', null, global);
goog.exportSymbol('proto.concierge_billing_publisher.BillingPublisherWithdrawalRequest', null, global);
goog.exportSymbol('proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse', null, global);
goog.exportSymbol('proto.concierge_billing_publisher.FeeLineItem', null, global);
goog.exportSymbol('proto.concierge_billing_publisher.FieldOption', null, global);
goog.exportSymbol('proto.concierge_billing_publisher.PayoutBankAccountType', null, global);
goog.exportSymbol('proto.concierge_billing_publisher.PayoutFeeOption', null, global);
goog.exportSymbol('proto.concierge_billing_publisher.PayoutFieldError', null, global);
goog.exportSymbol('proto.concierge_billing_publisher.PayoutFormField', null, global);
goog.exportSymbol('proto.concierge_billing_publisher.PayoutFormField.FieldType', null, global);
goog.exportSymbol('proto.concierge_billing_publisher.PublisherInvoiceRequest', null, global);
goog.exportSymbol('proto.concierge_billing_publisher.PublisherInvoiceResponse', null, global);
goog.exportSymbol('proto.concierge_billing_publisher.PublisherWithdrawalRequest', null, global);
goog.exportSymbol('proto.concierge_billing_publisher.PublisherWithdrawalResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest.displayName = 'proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsResponse.repeatedFields_, null);
};
goog.inherits(proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsResponse.displayName = 'proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing_publisher.PayoutBankAccountType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_billing_publisher.PayoutBankAccountType.repeatedFields_, null);
};
goog.inherits(proto.concierge_billing_publisher.PayoutBankAccountType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing_publisher.PayoutBankAccountType.displayName = 'proto.concierge_billing_publisher.PayoutBankAccountType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing_publisher.PayoutFormField = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_billing_publisher.PayoutFormField.repeatedFields_, null);
};
goog.inherits(proto.concierge_billing_publisher.PayoutFormField, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing_publisher.PayoutFormField.displayName = 'proto.concierge_billing_publisher.PayoutFormField';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing_publisher.FieldOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing_publisher.FieldOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing_publisher.FieldOption.displayName = 'proto.concierge_billing_publisher.FieldOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewRequest.displayName = 'proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewResponse.repeatedFields_, null);
};
goog.inherits(proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewResponse.displayName = 'proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing_publisher.PayoutFeeOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_billing_publisher.PayoutFeeOption.repeatedFields_, null);
};
goog.inherits(proto.concierge_billing_publisher.PayoutFeeOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing_publisher.PayoutFeeOption.displayName = 'proto.concierge_billing_publisher.PayoutFeeOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing_publisher.FeeLineItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing_publisher.FeeLineItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing_publisher.FeeLineItem.displayName = 'proto.concierge_billing_publisher.FeeLineItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing_publisher.PublisherInvoiceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing_publisher.PublisherInvoiceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing_publisher.PublisherInvoiceRequest.displayName = 'proto.concierge_billing_publisher.PublisherInvoiceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing_publisher.PublisherInvoiceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing_publisher.PublisherInvoiceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing_publisher.PublisherInvoiceResponse.displayName = 'proto.concierge_billing_publisher.PublisherInvoiceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing_publisher.PublisherWithdrawalRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing_publisher.PublisherWithdrawalRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing_publisher.PublisherWithdrawalRequest.displayName = 'proto.concierge_billing_publisher.PublisherWithdrawalRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing_publisher.PublisherWithdrawalResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing_publisher.PublisherWithdrawalResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing_publisher.PublisherWithdrawalResponse.displayName = 'proto.concierge_billing_publisher.PublisherWithdrawalResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing_publisher.BillingConciergePriceRangeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.repeatedFields_, null);
};
goog.inherits(proto.concierge_billing_publisher.BillingConciergePriceRangeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.displayName = 'proto.concierge_billing_publisher.BillingConciergePriceRangeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem.displayName = 'proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing_publisher.BillingConciergeDiscountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing_publisher.BillingConciergeDiscountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing_publisher.BillingConciergeDiscountRequest.displayName = 'proto.concierge_billing_publisher.BillingConciergeDiscountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing_publisher.BillingPublisherResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_billing_publisher.BillingPublisherResponse.repeatedFields_, null);
};
goog.inherits(proto.concierge_billing_publisher.BillingPublisherResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing_publisher.BillingPublisherResponse.displayName = 'proto.concierge_billing_publisher.BillingPublisherResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.concierge_billing_publisher.BillingPublisherPayoutSettings.oneofGroups_);
};
goog.inherits(proto.concierge_billing_publisher.BillingPublisherPayoutSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing_publisher.BillingPublisherPayoutSettings.displayName = 'proto.concierge_billing_publisher.BillingPublisherPayoutSettings';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing_publisher.BillingPublisherPayoutVerificationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing_publisher.BillingPublisherPayoutVerificationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing_publisher.BillingPublisherPayoutVerificationRequest.displayName = 'proto.concierge_billing_publisher.BillingPublisherPayoutVerificationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRemovingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing_publisher.BillingPublisherPayoutRemovingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing_publisher.BillingPublisherPayoutRemovingRequest.displayName = 'proto.concierge_billing_publisher.BillingPublisherPayoutRemovingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings.displayName = 'proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings.displayName = 'proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.displayName = 'proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings.displayName = 'proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing_publisher.BillingPublisherAddress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing_publisher.BillingPublisherAddress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing_publisher.BillingPublisherAddress.displayName = 'proto.concierge_billing_publisher.BillingPublisherAddress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing_publisher.BillingPublisherWithdrawalRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing_publisher.BillingPublisherWithdrawalRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing_publisher.BillingPublisherWithdrawalRequest.displayName = 'proto.concierge_billing_publisher.BillingPublisherWithdrawalRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse.displayName = 'proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse.repeatedFields_, null);
};
goog.inherits(proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse.displayName = 'proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.concierge_billing_publisher.PayoutFieldError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.concierge_billing_publisher.PayoutFieldError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.concierge_billing_publisher.PayoutFieldError.displayName = 'proto.concierge_billing_publisher.PayoutFieldError';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
currency: jspb.Message.getFieldWithDefault(msg, 1, ""),
country: jspb.Message.getFieldWithDefault(msg, 2, ""),
partialDetails: (f = msg.getPartialDetails()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest;
  return proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 3:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setPartialDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPartialDetails();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
};


/**
 * optional string currency = 1;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string country = 2;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Struct partial_details = 3;
 * @return {?proto.google.protobuf.Struct}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest.prototype.getPartialDetails = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 3));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest} returns this
*/
proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest.prototype.setPartialDetails = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest.prototype.clearPartialDetails = function() {
  return this.setPartialDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsRequest.prototype.hasPartialDetails = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
accountTypesList: jspb.Message.toObjectList(msg.getAccountTypesList(),
    proto.concierge_billing_publisher.PayoutBankAccountType.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsResponse}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsResponse;
  return proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsResponse}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.concierge_billing_publisher.PayoutBankAccountType;
      reader.readMessage(value,proto.concierge_billing_publisher.PayoutBankAccountType.deserializeBinaryFromReader);
      msg.addAccountTypes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountTypesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.concierge_billing_publisher.PayoutBankAccountType.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PayoutBankAccountType account_types = 1;
 * @return {!Array<!proto.concierge_billing_publisher.PayoutBankAccountType>}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsResponse.prototype.getAccountTypesList = function() {
  return /** @type{!Array<!proto.concierge_billing_publisher.PayoutBankAccountType>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_billing_publisher.PayoutBankAccountType, 1));
};


/**
 * @param {!Array<!proto.concierge_billing_publisher.PayoutBankAccountType>} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsResponse} returns this
*/
proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsResponse.prototype.setAccountTypesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.concierge_billing_publisher.PayoutBankAccountType=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_billing_publisher.PayoutBankAccountType}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsResponse.prototype.addAccountTypes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.concierge_billing_publisher.PayoutBankAccountType, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsResponse} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRequirementsResponse.prototype.clearAccountTypesList = function() {
  return this.setAccountTypesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_billing_publisher.PayoutBankAccountType.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing_publisher.PayoutBankAccountType.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing_publisher.PayoutBankAccountType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing_publisher.PayoutBankAccountType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.PayoutBankAccountType.toObject = function(includeInstance, msg) {
  var f, obj = {
type: jspb.Message.getFieldWithDefault(msg, 1, ""),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
fieldsList: jspb.Message.toObjectList(msg.getFieldsList(),
    proto.concierge_billing_publisher.PayoutFormField.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing_publisher.PayoutBankAccountType}
 */
proto.concierge_billing_publisher.PayoutBankAccountType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing_publisher.PayoutBankAccountType;
  return proto.concierge_billing_publisher.PayoutBankAccountType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing_publisher.PayoutBankAccountType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing_publisher.PayoutBankAccountType}
 */
proto.concierge_billing_publisher.PayoutBankAccountType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = new proto.concierge_billing_publisher.PayoutFormField;
      reader.readMessage(value,proto.concierge_billing_publisher.PayoutFormField.deserializeBinaryFromReader);
      msg.addFields(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing_publisher.PayoutBankAccountType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing_publisher.PayoutBankAccountType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing_publisher.PayoutBankAccountType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.PayoutBankAccountType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFieldsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.concierge_billing_publisher.PayoutFormField.serializeBinaryToWriter
    );
  }
};


/**
 * optional string type = 1;
 * @return {string}
 */
proto.concierge_billing_publisher.PayoutBankAccountType.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.PayoutBankAccountType} returns this
 */
proto.concierge_billing_publisher.PayoutBankAccountType.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.concierge_billing_publisher.PayoutBankAccountType.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.PayoutBankAccountType} returns this
 */
proto.concierge_billing_publisher.PayoutBankAccountType.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated PayoutFormField fields = 3;
 * @return {!Array<!proto.concierge_billing_publisher.PayoutFormField>}
 */
proto.concierge_billing_publisher.PayoutBankAccountType.prototype.getFieldsList = function() {
  return /** @type{!Array<!proto.concierge_billing_publisher.PayoutFormField>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_billing_publisher.PayoutFormField, 3));
};


/**
 * @param {!Array<!proto.concierge_billing_publisher.PayoutFormField>} value
 * @return {!proto.concierge_billing_publisher.PayoutBankAccountType} returns this
*/
proto.concierge_billing_publisher.PayoutBankAccountType.prototype.setFieldsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.concierge_billing_publisher.PayoutFormField=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_billing_publisher.PayoutFormField}
 */
proto.concierge_billing_publisher.PayoutBankAccountType.prototype.addFields = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.concierge_billing_publisher.PayoutFormField, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_billing_publisher.PayoutBankAccountType} returns this
 */
proto.concierge_billing_publisher.PayoutBankAccountType.prototype.clearFieldsList = function() {
  return this.setFieldsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_billing_publisher.PayoutFormField.repeatedFields_ = [10];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing_publisher.PayoutFormField.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing_publisher.PayoutFormField.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing_publisher.PayoutFormField} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.PayoutFormField.toObject = function(includeInstance, msg) {
  var f, obj = {
key: jspb.Message.getFieldWithDefault(msg, 1, ""),
label: jspb.Message.getFieldWithDefault(msg, 2, ""),
type: jspb.Message.getFieldWithDefault(msg, 3, 0),
required: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
example: jspb.Message.getFieldWithDefault(msg, 5, ""),
displayFormat: jspb.Message.getFieldWithDefault(msg, 6, ""),
minLength: jspb.Message.getFieldWithDefault(msg, 7, 0),
maxLength: jspb.Message.getFieldWithDefault(msg, 8, 0),
validationRegexp: jspb.Message.getFieldWithDefault(msg, 9, ""),
optionsList: jspb.Message.toObjectList(msg.getOptionsList(),
    proto.concierge_billing_publisher.FieldOption.toObject, includeInstance),
refreshOnChange: jspb.Message.getBooleanFieldWithDefault(msg, 11, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing_publisher.PayoutFormField}
 */
proto.concierge_billing_publisher.PayoutFormField.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing_publisher.PayoutFormField;
  return proto.concierge_billing_publisher.PayoutFormField.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing_publisher.PayoutFormField} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing_publisher.PayoutFormField}
 */
proto.concierge_billing_publisher.PayoutFormField.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 3:
      var value = /** @type {!proto.concierge_billing_publisher.PayoutFormField.FieldType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRequired(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setExample(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayFormat(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinLength(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxLength(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setValidationRegexp(value);
      break;
    case 10:
      var value = new proto.concierge_billing_publisher.FieldOption;
      reader.readMessage(value,proto.concierge_billing_publisher.FieldOption.deserializeBinaryFromReader);
      msg.addOptions(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRefreshOnChange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing_publisher.PayoutFormField.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing_publisher.PayoutFormField.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing_publisher.PayoutFormField} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.PayoutFormField.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getRequired();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getExample();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDisplayFormat();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMinLength();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getMaxLength();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getValidationRegexp();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      proto.concierge_billing_publisher.FieldOption.serializeBinaryToWriter
    );
  }
  f = message.getRefreshOnChange();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.concierge_billing_publisher.PayoutFormField.FieldType = {
  FIELD_TYPE_UNSPECIFIED: 0,
  TEXT: 1,
  SELECT: 2,
  RADIO: 3,
  DATE: 4
};

/**
 * optional string key = 1;
 * @return {string}
 */
proto.concierge_billing_publisher.PayoutFormField.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.PayoutFormField} returns this
 */
proto.concierge_billing_publisher.PayoutFormField.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.concierge_billing_publisher.PayoutFormField.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.PayoutFormField} returns this
 */
proto.concierge_billing_publisher.PayoutFormField.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional FieldType type = 3;
 * @return {!proto.concierge_billing_publisher.PayoutFormField.FieldType}
 */
proto.concierge_billing_publisher.PayoutFormField.prototype.getType = function() {
  return /** @type {!proto.concierge_billing_publisher.PayoutFormField.FieldType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.concierge_billing_publisher.PayoutFormField.FieldType} value
 * @return {!proto.concierge_billing_publisher.PayoutFormField} returns this
 */
proto.concierge_billing_publisher.PayoutFormField.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional bool required = 4;
 * @return {boolean}
 */
proto.concierge_billing_publisher.PayoutFormField.prototype.getRequired = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_billing_publisher.PayoutFormField} returns this
 */
proto.concierge_billing_publisher.PayoutFormField.prototype.setRequired = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string example = 5;
 * @return {string}
 */
proto.concierge_billing_publisher.PayoutFormField.prototype.getExample = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.PayoutFormField} returns this
 */
proto.concierge_billing_publisher.PayoutFormField.prototype.setExample = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string display_format = 6;
 * @return {string}
 */
proto.concierge_billing_publisher.PayoutFormField.prototype.getDisplayFormat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.PayoutFormField} returns this
 */
proto.concierge_billing_publisher.PayoutFormField.prototype.setDisplayFormat = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 min_length = 7;
 * @return {number}
 */
proto.concierge_billing_publisher.PayoutFormField.prototype.getMinLength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.PayoutFormField} returns this
 */
proto.concierge_billing_publisher.PayoutFormField.prototype.setMinLength = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 max_length = 8;
 * @return {number}
 */
proto.concierge_billing_publisher.PayoutFormField.prototype.getMaxLength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.PayoutFormField} returns this
 */
proto.concierge_billing_publisher.PayoutFormField.prototype.setMaxLength = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string validation_regexp = 9;
 * @return {string}
 */
proto.concierge_billing_publisher.PayoutFormField.prototype.getValidationRegexp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.PayoutFormField} returns this
 */
proto.concierge_billing_publisher.PayoutFormField.prototype.setValidationRegexp = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * repeated FieldOption options = 10;
 * @return {!Array<!proto.concierge_billing_publisher.FieldOption>}
 */
proto.concierge_billing_publisher.PayoutFormField.prototype.getOptionsList = function() {
  return /** @type{!Array<!proto.concierge_billing_publisher.FieldOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_billing_publisher.FieldOption, 10));
};


/**
 * @param {!Array<!proto.concierge_billing_publisher.FieldOption>} value
 * @return {!proto.concierge_billing_publisher.PayoutFormField} returns this
*/
proto.concierge_billing_publisher.PayoutFormField.prototype.setOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.concierge_billing_publisher.FieldOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_billing_publisher.FieldOption}
 */
proto.concierge_billing_publisher.PayoutFormField.prototype.addOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.concierge_billing_publisher.FieldOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_billing_publisher.PayoutFormField} returns this
 */
proto.concierge_billing_publisher.PayoutFormField.prototype.clearOptionsList = function() {
  return this.setOptionsList([]);
};


/**
 * optional bool refresh_on_change = 11;
 * @return {boolean}
 */
proto.concierge_billing_publisher.PayoutFormField.prototype.getRefreshOnChange = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_billing_publisher.PayoutFormField} returns this
 */
proto.concierge_billing_publisher.PayoutFormField.prototype.setRefreshOnChange = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing_publisher.FieldOption.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing_publisher.FieldOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing_publisher.FieldOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.FieldOption.toObject = function(includeInstance, msg) {
  var f, obj = {
key: jspb.Message.getFieldWithDefault(msg, 1, ""),
label: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing_publisher.FieldOption}
 */
proto.concierge_billing_publisher.FieldOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing_publisher.FieldOption;
  return proto.concierge_billing_publisher.FieldOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing_publisher.FieldOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing_publisher.FieldOption}
 */
proto.concierge_billing_publisher.FieldOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing_publisher.FieldOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing_publisher.FieldOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing_publisher.FieldOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.FieldOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.concierge_billing_publisher.FieldOption.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.FieldOption} returns this
 */
proto.concierge_billing_publisher.FieldOption.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.concierge_billing_publisher.FieldOption.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.FieldOption} returns this
 */
proto.concierge_billing_publisher.FieldOption.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
targetCurrency: jspb.Message.getFieldWithDefault(msg, 1, ""),
sourceAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
recipientId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewRequest}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewRequest;
  return proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewRequest}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetCurrency(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSourceAmount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecipientId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTargetCurrency();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSourceAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getRecipientId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string target_currency = 1;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewRequest.prototype.getTargetCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewRequest} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewRequest.prototype.setTargetCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double source_amount = 2;
 * @return {number}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewRequest.prototype.getSourceAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewRequest} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewRequest.prototype.setSourceAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional string recipient_id = 3;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewRequest.prototype.getRecipientId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewRequest} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewRequest.prototype.setRecipientId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
optionsList: jspb.Message.toObjectList(msg.getOptionsList(),
    proto.concierge_billing_publisher.PayoutFeeOption.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewResponse}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewResponse;
  return proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewResponse}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.concierge_billing_publisher.PayoutFeeOption;
      reader.readMessage(value,proto.concierge_billing_publisher.PayoutFeeOption.deserializeBinaryFromReader);
      msg.addOptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.concierge_billing_publisher.PayoutFeeOption.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PayoutFeeOption options = 1;
 * @return {!Array<!proto.concierge_billing_publisher.PayoutFeeOption>}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewResponse.prototype.getOptionsList = function() {
  return /** @type{!Array<!proto.concierge_billing_publisher.PayoutFeeOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_billing_publisher.PayoutFeeOption, 1));
};


/**
 * @param {!Array<!proto.concierge_billing_publisher.PayoutFeeOption>} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewResponse} returns this
*/
proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewResponse.prototype.setOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.concierge_billing_publisher.PayoutFeeOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_billing_publisher.PayoutFeeOption}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewResponse.prototype.addOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.concierge_billing_publisher.PayoutFeeOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewResponse} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPayoutFeePreviewResponse.prototype.clearOptionsList = function() {
  return this.setOptionsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_billing_publisher.PayoutFeeOption.repeatedFields_ = [10];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing_publisher.PayoutFeeOption.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing_publisher.PayoutFeeOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing_publisher.PayoutFeeOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.PayoutFeeOption.toObject = function(includeInstance, msg) {
  var f, obj = {
payoutType: jspb.Message.getFieldWithDefault(msg, 1, ""),
feeTotal: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
feeCurrency: jspb.Message.getFieldWithDefault(msg, 3, ""),
targetAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
targetCurrency: jspb.Message.getFieldWithDefault(msg, 5, ""),
rate: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
estimatedDelivery: jspb.Message.getFieldWithDefault(msg, 7, ""),
disabled: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
disabledReason: jspb.Message.getFieldWithDefault(msg, 9, ""),
lineItemsList: jspb.Message.toObjectList(msg.getLineItemsList(),
    proto.concierge_billing_publisher.FeeLineItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing_publisher.PayoutFeeOption}
 */
proto.concierge_billing_publisher.PayoutFeeOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing_publisher.PayoutFeeOption;
  return proto.concierge_billing_publisher.PayoutFeeOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing_publisher.PayoutFeeOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing_publisher.PayoutFeeOption}
 */
proto.concierge_billing_publisher.PayoutFeeOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPayoutType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setFeeTotal(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFeeCurrency(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTargetAmount(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetCurrency(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRate(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setEstimatedDelivery(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisabled(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisabledReason(value);
      break;
    case 10:
      var value = new proto.concierge_billing_publisher.FeeLineItem;
      reader.readMessage(value,proto.concierge_billing_publisher.FeeLineItem.deserializeBinaryFromReader);
      msg.addLineItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing_publisher.PayoutFeeOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing_publisher.PayoutFeeOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing_publisher.PayoutFeeOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.PayoutFeeOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPayoutType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFeeTotal();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getFeeCurrency();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTargetAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getTargetCurrency();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRate();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getEstimatedDelivery();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getDisabled();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getDisabledReason();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getLineItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      proto.concierge_billing_publisher.FeeLineItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional string payout_type = 1;
 * @return {string}
 */
proto.concierge_billing_publisher.PayoutFeeOption.prototype.getPayoutType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.PayoutFeeOption} returns this
 */
proto.concierge_billing_publisher.PayoutFeeOption.prototype.setPayoutType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double fee_total = 2;
 * @return {number}
 */
proto.concierge_billing_publisher.PayoutFeeOption.prototype.getFeeTotal = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.PayoutFeeOption} returns this
 */
proto.concierge_billing_publisher.PayoutFeeOption.prototype.setFeeTotal = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional string fee_currency = 3;
 * @return {string}
 */
proto.concierge_billing_publisher.PayoutFeeOption.prototype.getFeeCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.PayoutFeeOption} returns this
 */
proto.concierge_billing_publisher.PayoutFeeOption.prototype.setFeeCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional double target_amount = 4;
 * @return {number}
 */
proto.concierge_billing_publisher.PayoutFeeOption.prototype.getTargetAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.PayoutFeeOption} returns this
 */
proto.concierge_billing_publisher.PayoutFeeOption.prototype.setTargetAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional string target_currency = 5;
 * @return {string}
 */
proto.concierge_billing_publisher.PayoutFeeOption.prototype.getTargetCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.PayoutFeeOption} returns this
 */
proto.concierge_billing_publisher.PayoutFeeOption.prototype.setTargetCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional double rate = 6;
 * @return {number}
 */
proto.concierge_billing_publisher.PayoutFeeOption.prototype.getRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.PayoutFeeOption} returns this
 */
proto.concierge_billing_publisher.PayoutFeeOption.prototype.setRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional string estimated_delivery = 7;
 * @return {string}
 */
proto.concierge_billing_publisher.PayoutFeeOption.prototype.getEstimatedDelivery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.PayoutFeeOption} returns this
 */
proto.concierge_billing_publisher.PayoutFeeOption.prototype.setEstimatedDelivery = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool disabled = 8;
 * @return {boolean}
 */
proto.concierge_billing_publisher.PayoutFeeOption.prototype.getDisabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_billing_publisher.PayoutFeeOption} returns this
 */
proto.concierge_billing_publisher.PayoutFeeOption.prototype.setDisabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional string disabled_reason = 9;
 * @return {string}
 */
proto.concierge_billing_publisher.PayoutFeeOption.prototype.getDisabledReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.PayoutFeeOption} returns this
 */
proto.concierge_billing_publisher.PayoutFeeOption.prototype.setDisabledReason = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * repeated FeeLineItem line_items = 10;
 * @return {!Array<!proto.concierge_billing_publisher.FeeLineItem>}
 */
proto.concierge_billing_publisher.PayoutFeeOption.prototype.getLineItemsList = function() {
  return /** @type{!Array<!proto.concierge_billing_publisher.FeeLineItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_billing_publisher.FeeLineItem, 10));
};


/**
 * @param {!Array<!proto.concierge_billing_publisher.FeeLineItem>} value
 * @return {!proto.concierge_billing_publisher.PayoutFeeOption} returns this
*/
proto.concierge_billing_publisher.PayoutFeeOption.prototype.setLineItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.concierge_billing_publisher.FeeLineItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_billing_publisher.FeeLineItem}
 */
proto.concierge_billing_publisher.PayoutFeeOption.prototype.addLineItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.concierge_billing_publisher.FeeLineItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_billing_publisher.PayoutFeeOption} returns this
 */
proto.concierge_billing_publisher.PayoutFeeOption.prototype.clearLineItemsList = function() {
  return this.setLineItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing_publisher.FeeLineItem.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing_publisher.FeeLineItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing_publisher.FeeLineItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.FeeLineItem.toObject = function(includeInstance, msg) {
  var f, obj = {
label: jspb.Message.getFieldWithDefault(msg, 1, ""),
amount: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
currency: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing_publisher.FeeLineItem}
 */
proto.concierge_billing_publisher.FeeLineItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing_publisher.FeeLineItem;
  return proto.concierge_billing_publisher.FeeLineItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing_publisher.FeeLineItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing_publisher.FeeLineItem}
 */
proto.concierge_billing_publisher.FeeLineItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAmount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing_publisher.FeeLineItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing_publisher.FeeLineItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing_publisher.FeeLineItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.FeeLineItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string label = 1;
 * @return {string}
 */
proto.concierge_billing_publisher.FeeLineItem.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.FeeLineItem} returns this
 */
proto.concierge_billing_publisher.FeeLineItem.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double amount = 2;
 * @return {number}
 */
proto.concierge_billing_publisher.FeeLineItem.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.FeeLineItem} returns this
 */
proto.concierge_billing_publisher.FeeLineItem.prototype.setAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional string currency = 3;
 * @return {string}
 */
proto.concierge_billing_publisher.FeeLineItem.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.FeeLineItem} returns this
 */
proto.concierge_billing_publisher.FeeLineItem.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing_publisher.PublisherInvoiceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing_publisher.PublisherInvoiceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing_publisher.PublisherInvoiceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.PublisherInvoiceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
query: jspb.Message.getFieldWithDefault(msg, 1, ""),
dateRange: (f = msg.getDateRange()) && common_pb.TimestampRange.toObject(includeInstance, f),
page: jspb.Message.getFieldWithDefault(msg, 3, 0),
limit: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing_publisher.PublisherInvoiceRequest}
 */
proto.concierge_billing_publisher.PublisherInvoiceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing_publisher.PublisherInvoiceRequest;
  return proto.concierge_billing_publisher.PublisherInvoiceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing_publisher.PublisherInvoiceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing_publisher.PublisherInvoiceRequest}
 */
proto.concierge_billing_publisher.PublisherInvoiceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    case 2:
      var value = new common_pb.TimestampRange;
      reader.readMessage(value,common_pb.TimestampRange.deserializeBinaryFromReader);
      msg.setDateRange(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing_publisher.PublisherInvoiceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing_publisher.PublisherInvoiceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing_publisher.PublisherInvoiceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.PublisherInvoiceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDateRange();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_pb.TimestampRange.serializeBinaryToWriter
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string query = 1;
 * @return {string}
 */
proto.concierge_billing_publisher.PublisherInvoiceRequest.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.PublisherInvoiceRequest} returns this
 */
proto.concierge_billing_publisher.PublisherInvoiceRequest.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional common.TimestampRange date_range = 2;
 * @return {?proto.common.TimestampRange}
 */
proto.concierge_billing_publisher.PublisherInvoiceRequest.prototype.getDateRange = function() {
  return /** @type{?proto.common.TimestampRange} */ (
    jspb.Message.getWrapperField(this, common_pb.TimestampRange, 2));
};


/**
 * @param {?proto.common.TimestampRange|undefined} value
 * @return {!proto.concierge_billing_publisher.PublisherInvoiceRequest} returns this
*/
proto.concierge_billing_publisher.PublisherInvoiceRequest.prototype.setDateRange = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.concierge_billing_publisher.PublisherInvoiceRequest} returns this
 */
proto.concierge_billing_publisher.PublisherInvoiceRequest.prototype.clearDateRange = function() {
  return this.setDateRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.concierge_billing_publisher.PublisherInvoiceRequest.prototype.hasDateRange = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 page = 3;
 * @return {number}
 */
proto.concierge_billing_publisher.PublisherInvoiceRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.PublisherInvoiceRequest} returns this
 */
proto.concierge_billing_publisher.PublisherInvoiceRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 limit = 4;
 * @return {number}
 */
proto.concierge_billing_publisher.PublisherInvoiceRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.PublisherInvoiceRequest} returns this
 */
proto.concierge_billing_publisher.PublisherInvoiceRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing_publisher.PublisherInvoiceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing_publisher.PublisherInvoiceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing_publisher.PublisherInvoiceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.PublisherInvoiceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
number: jspb.Message.getFieldWithDefault(msg, 2, ""),
date: jspb.Message.getFieldWithDefault(msg, 3, 0),
websiteId: jspb.Message.getFieldWithDefault(msg, 4, 0),
websiteDomain: jspb.Message.getFieldWithDefault(msg, 5, ""),
amount: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
status: jspb.Message.getFieldWithDefault(msg, 7, 0),
totalItems: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing_publisher.PublisherInvoiceResponse}
 */
proto.concierge_billing_publisher.PublisherInvoiceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing_publisher.PublisherInvoiceResponse;
  return proto.concierge_billing_publisher.PublisherInvoiceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing_publisher.PublisherInvoiceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing_publisher.PublisherInvoiceResponse}
 */
proto.concierge_billing_publisher.PublisherInvoiceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDate(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWebsiteId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setWebsiteDomain(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAmount(value);
      break;
    case 7:
      var value = /** @type {!proto.common.BillingPublisherInvoiceStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing_publisher.PublisherInvoiceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing_publisher.PublisherInvoiceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing_publisher.PublisherInvoiceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.PublisherInvoiceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getNumber();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDate();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getWebsiteId();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getWebsiteDomain();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getTotalItems();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.concierge_billing_publisher.PublisherInvoiceResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.PublisherInvoiceResponse} returns this
 */
proto.concierge_billing_publisher.PublisherInvoiceResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string number = 2;
 * @return {string}
 */
proto.concierge_billing_publisher.PublisherInvoiceResponse.prototype.getNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.PublisherInvoiceResponse} returns this
 */
proto.concierge_billing_publisher.PublisherInvoiceResponse.prototype.setNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 date = 3;
 * @return {number}
 */
proto.concierge_billing_publisher.PublisherInvoiceResponse.prototype.getDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.PublisherInvoiceResponse} returns this
 */
proto.concierge_billing_publisher.PublisherInvoiceResponse.prototype.setDate = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 website_id = 4;
 * @return {number}
 */
proto.concierge_billing_publisher.PublisherInvoiceResponse.prototype.getWebsiteId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.PublisherInvoiceResponse} returns this
 */
proto.concierge_billing_publisher.PublisherInvoiceResponse.prototype.setWebsiteId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string website_domain = 5;
 * @return {string}
 */
proto.concierge_billing_publisher.PublisherInvoiceResponse.prototype.getWebsiteDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.PublisherInvoiceResponse} returns this
 */
proto.concierge_billing_publisher.PublisherInvoiceResponse.prototype.setWebsiteDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional double amount = 6;
 * @return {number}
 */
proto.concierge_billing_publisher.PublisherInvoiceResponse.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.PublisherInvoiceResponse} returns this
 */
proto.concierge_billing_publisher.PublisherInvoiceResponse.prototype.setAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional common.BillingPublisherInvoiceStatus status = 7;
 * @return {!proto.common.BillingPublisherInvoiceStatus}
 */
proto.concierge_billing_publisher.PublisherInvoiceResponse.prototype.getStatus = function() {
  return /** @type {!proto.common.BillingPublisherInvoiceStatus} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.common.BillingPublisherInvoiceStatus} value
 * @return {!proto.concierge_billing_publisher.PublisherInvoiceResponse} returns this
 */
proto.concierge_billing_publisher.PublisherInvoiceResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional int32 total_items = 8;
 * @return {number}
 */
proto.concierge_billing_publisher.PublisherInvoiceResponse.prototype.getTotalItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.PublisherInvoiceResponse} returns this
 */
proto.concierge_billing_publisher.PublisherInvoiceResponse.prototype.setTotalItems = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing_publisher.PublisherWithdrawalRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing_publisher.PublisherWithdrawalRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing_publisher.PublisherWithdrawalRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.PublisherWithdrawalRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
query: jspb.Message.getFieldWithDefault(msg, 1, ""),
dateRange: (f = msg.getDateRange()) && common_pb.TimestampRange.toObject(includeInstance, f),
page: jspb.Message.getFieldWithDefault(msg, 3, 0),
limit: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing_publisher.PublisherWithdrawalRequest}
 */
proto.concierge_billing_publisher.PublisherWithdrawalRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing_publisher.PublisherWithdrawalRequest;
  return proto.concierge_billing_publisher.PublisherWithdrawalRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing_publisher.PublisherWithdrawalRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing_publisher.PublisherWithdrawalRequest}
 */
proto.concierge_billing_publisher.PublisherWithdrawalRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    case 2:
      var value = new common_pb.TimestampRange;
      reader.readMessage(value,common_pb.TimestampRange.deserializeBinaryFromReader);
      msg.setDateRange(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing_publisher.PublisherWithdrawalRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing_publisher.PublisherWithdrawalRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing_publisher.PublisherWithdrawalRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.PublisherWithdrawalRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDateRange();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_pb.TimestampRange.serializeBinaryToWriter
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string query = 1;
 * @return {string}
 */
proto.concierge_billing_publisher.PublisherWithdrawalRequest.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.PublisherWithdrawalRequest} returns this
 */
proto.concierge_billing_publisher.PublisherWithdrawalRequest.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional common.TimestampRange date_range = 2;
 * @return {?proto.common.TimestampRange}
 */
proto.concierge_billing_publisher.PublisherWithdrawalRequest.prototype.getDateRange = function() {
  return /** @type{?proto.common.TimestampRange} */ (
    jspb.Message.getWrapperField(this, common_pb.TimestampRange, 2));
};


/**
 * @param {?proto.common.TimestampRange|undefined} value
 * @return {!proto.concierge_billing_publisher.PublisherWithdrawalRequest} returns this
*/
proto.concierge_billing_publisher.PublisherWithdrawalRequest.prototype.setDateRange = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.concierge_billing_publisher.PublisherWithdrawalRequest} returns this
 */
proto.concierge_billing_publisher.PublisherWithdrawalRequest.prototype.clearDateRange = function() {
  return this.setDateRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.concierge_billing_publisher.PublisherWithdrawalRequest.prototype.hasDateRange = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 page = 3;
 * @return {number}
 */
proto.concierge_billing_publisher.PublisherWithdrawalRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.PublisherWithdrawalRequest} returns this
 */
proto.concierge_billing_publisher.PublisherWithdrawalRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 limit = 4;
 * @return {number}
 */
proto.concierge_billing_publisher.PublisherWithdrawalRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.PublisherWithdrawalRequest} returns this
 */
proto.concierge_billing_publisher.PublisherWithdrawalRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing_publisher.PublisherWithdrawalResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing_publisher.PublisherWithdrawalResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing_publisher.PublisherWithdrawalResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.PublisherWithdrawalResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
transactionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
withdrawalOn: jspb.Message.getFieldWithDefault(msg, 3, 0),
withdrawalByUserId: jspb.Message.getFieldWithDefault(msg, 4, 0),
amount: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
paymentSettings: (f = msg.getPaymentSettings()) && proto.concierge_billing_publisher.BillingPublisherPayoutSettings.toObject(includeInstance, f),
status: jspb.Message.getFieldWithDefault(msg, 7, 0),
totalItems: jspb.Message.getFieldWithDefault(msg, 8, 0),
errorNote: jspb.Message.getFieldWithDefault(msg, 9, ""),
fee: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing_publisher.PublisherWithdrawalResponse}
 */
proto.concierge_billing_publisher.PublisherWithdrawalResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing_publisher.PublisherWithdrawalResponse;
  return proto.concierge_billing_publisher.PublisherWithdrawalResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing_publisher.PublisherWithdrawalResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing_publisher.PublisherWithdrawalResponse}
 */
proto.concierge_billing_publisher.PublisherWithdrawalResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWithdrawalOn(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWithdrawalByUserId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAmount(value);
      break;
    case 6:
      var value = new proto.concierge_billing_publisher.BillingPublisherPayoutSettings;
      reader.readMessage(value,proto.concierge_billing_publisher.BillingPublisherPayoutSettings.deserializeBinaryFromReader);
      msg.setPaymentSettings(value);
      break;
    case 7:
      var value = /** @type {!proto.common.BillingPublisherWithdrawalStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalItems(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorNote(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setFee(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing_publisher.PublisherWithdrawalResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing_publisher.PublisherWithdrawalResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing_publisher.PublisherWithdrawalResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.PublisherWithdrawalResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTransactionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getWithdrawalOn();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getWithdrawalByUserId();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getPaymentSettings();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.concierge_billing_publisher.BillingPublisherPayoutSettings.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getTotalItems();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getErrorNote();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getFee();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.concierge_billing_publisher.PublisherWithdrawalResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.PublisherWithdrawalResponse} returns this
 */
proto.concierge_billing_publisher.PublisherWithdrawalResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string transaction_id = 2;
 * @return {string}
 */
proto.concierge_billing_publisher.PublisherWithdrawalResponse.prototype.getTransactionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.PublisherWithdrawalResponse} returns this
 */
proto.concierge_billing_publisher.PublisherWithdrawalResponse.prototype.setTransactionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 withdrawal_on = 3;
 * @return {number}
 */
proto.concierge_billing_publisher.PublisherWithdrawalResponse.prototype.getWithdrawalOn = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.PublisherWithdrawalResponse} returns this
 */
proto.concierge_billing_publisher.PublisherWithdrawalResponse.prototype.setWithdrawalOn = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 withdrawal_by_user_id = 4;
 * @return {number}
 */
proto.concierge_billing_publisher.PublisherWithdrawalResponse.prototype.getWithdrawalByUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.PublisherWithdrawalResponse} returns this
 */
proto.concierge_billing_publisher.PublisherWithdrawalResponse.prototype.setWithdrawalByUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional double amount = 5;
 * @return {number}
 */
proto.concierge_billing_publisher.PublisherWithdrawalResponse.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.PublisherWithdrawalResponse} returns this
 */
proto.concierge_billing_publisher.PublisherWithdrawalResponse.prototype.setAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional BillingPublisherPayoutSettings payment_settings = 6;
 * @return {?proto.concierge_billing_publisher.BillingPublisherPayoutSettings}
 */
proto.concierge_billing_publisher.PublisherWithdrawalResponse.prototype.getPaymentSettings = function() {
  return /** @type{?proto.concierge_billing_publisher.BillingPublisherPayoutSettings} */ (
    jspb.Message.getWrapperField(this, proto.concierge_billing_publisher.BillingPublisherPayoutSettings, 6));
};


/**
 * @param {?proto.concierge_billing_publisher.BillingPublisherPayoutSettings|undefined} value
 * @return {!proto.concierge_billing_publisher.PublisherWithdrawalResponse} returns this
*/
proto.concierge_billing_publisher.PublisherWithdrawalResponse.prototype.setPaymentSettings = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.concierge_billing_publisher.PublisherWithdrawalResponse} returns this
 */
proto.concierge_billing_publisher.PublisherWithdrawalResponse.prototype.clearPaymentSettings = function() {
  return this.setPaymentSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.concierge_billing_publisher.PublisherWithdrawalResponse.prototype.hasPaymentSettings = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional common.BillingPublisherWithdrawalStatus status = 7;
 * @return {!proto.common.BillingPublisherWithdrawalStatus}
 */
proto.concierge_billing_publisher.PublisherWithdrawalResponse.prototype.getStatus = function() {
  return /** @type {!proto.common.BillingPublisherWithdrawalStatus} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.common.BillingPublisherWithdrawalStatus} value
 * @return {!proto.concierge_billing_publisher.PublisherWithdrawalResponse} returns this
 */
proto.concierge_billing_publisher.PublisherWithdrawalResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional int32 total_items = 8;
 * @return {number}
 */
proto.concierge_billing_publisher.PublisherWithdrawalResponse.prototype.getTotalItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.PublisherWithdrawalResponse} returns this
 */
proto.concierge_billing_publisher.PublisherWithdrawalResponse.prototype.setTotalItems = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string error_note = 9;
 * @return {string}
 */
proto.concierge_billing_publisher.PublisherWithdrawalResponse.prototype.getErrorNote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.PublisherWithdrawalResponse} returns this
 */
proto.concierge_billing_publisher.PublisherWithdrawalResponse.prototype.setErrorNote = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional double fee = 10;
 * @return {number}
 */
proto.concierge_billing_publisher.PublisherWithdrawalResponse.prototype.getFee = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.PublisherWithdrawalResponse} returns this
 */
proto.concierge_billing_publisher.PublisherWithdrawalResponse.prototype.setFee = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing_publisher.BillingConciergePriceRangeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing_publisher.BillingConciergePriceRangeResponse}
 */
proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing_publisher.BillingConciergePriceRangeResponse;
  return proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing_publisher.BillingConciergePriceRangeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing_publisher.BillingConciergePriceRangeResponse}
 */
proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem;
      reader.readMessage(value,proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing_publisher.BillingConciergePriceRangeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem.toObject = function(includeInstance, msg) {
  var f, obj = {
order: jspb.Message.getFieldWithDefault(msg, 1, 0),
amount: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
discount: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem}
 */
proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem;
  return proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem}
 */
proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrder(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAmount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDiscount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrder();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getDiscount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 order = 1;
 * @return {number}
 */
proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem.prototype.getOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem} returns this
 */
proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem.prototype.setOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional double amount = 2;
 * @return {number}
 */
proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem} returns this
 */
proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem.prototype.setAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional int32 discount = 3;
 * @return {number}
 */
proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem.prototype.getDiscount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem} returns this
 */
proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem.prototype.setDiscount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated PriceItem items = 1;
 * @return {!Array<!proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem>}
 */
proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem, 1));
};


/**
 * @param {!Array<!proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem>} value
 * @return {!proto.concierge_billing_publisher.BillingConciergePriceRangeResponse} returns this
*/
proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem}
 */
proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.PriceItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_billing_publisher.BillingConciergePriceRangeResponse} returns this
 */
proto.concierge_billing_publisher.BillingConciergePriceRangeResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing_publisher.BillingConciergeDiscountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing_publisher.BillingConciergeDiscountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing_publisher.BillingConciergeDiscountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingConciergeDiscountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
amount: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing_publisher.BillingConciergeDiscountRequest}
 */
proto.concierge_billing_publisher.BillingConciergeDiscountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing_publisher.BillingConciergeDiscountRequest;
  return proto.concierge_billing_publisher.BillingConciergeDiscountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing_publisher.BillingConciergeDiscountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing_publisher.BillingConciergeDiscountRequest}
 */
proto.concierge_billing_publisher.BillingConciergeDiscountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing_publisher.BillingConciergeDiscountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing_publisher.BillingConciergeDiscountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing_publisher.BillingConciergeDiscountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingConciergeDiscountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 amount = 1;
 * @return {number}
 */
proto.concierge_billing_publisher.BillingConciergeDiscountRequest.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.BillingConciergeDiscountRequest} returns this
 */
proto.concierge_billing_publisher.BillingConciergeDiscountRequest.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_billing_publisher.BillingPublisherResponse.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing_publisher.BillingPublisherResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing_publisher.BillingPublisherResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing_publisher.BillingPublisherResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
availableFunds: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
pendingFunds: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
ownerEmail: jspb.Message.getFieldWithDefault(msg, 4, ""),
address: (f = msg.getAddress()) && proto.concierge_billing_publisher.BillingPublisherAddress.toObject(includeInstance, f),
paymentSettingsList: jspb.Message.toObjectList(msg.getPaymentSettingsList(),
    proto.concierge_billing_publisher.BillingPublisherPayoutSettings.toObject, includeInstance),
inWithdrawalFunds: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
websiteLimit: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing_publisher.BillingPublisherResponse}
 */
proto.concierge_billing_publisher.BillingPublisherResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing_publisher.BillingPublisherResponse;
  return proto.concierge_billing_publisher.BillingPublisherResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing_publisher.BillingPublisherResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing_publisher.BillingPublisherResponse}
 */
proto.concierge_billing_publisher.BillingPublisherResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAvailableFunds(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPendingFunds(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwnerEmail(value);
      break;
    case 5:
      var value = new proto.concierge_billing_publisher.BillingPublisherAddress;
      reader.readMessage(value,proto.concierge_billing_publisher.BillingPublisherAddress.deserializeBinaryFromReader);
      msg.setAddress(value);
      break;
    case 6:
      var value = new proto.concierge_billing_publisher.BillingPublisherPayoutSettings;
      reader.readMessage(value,proto.concierge_billing_publisher.BillingPublisherPayoutSettings.deserializeBinaryFromReader);
      msg.addPaymentSettings(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setInWithdrawalFunds(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWebsiteLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing_publisher.BillingPublisherResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing_publisher.BillingPublisherResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing_publisher.BillingPublisherResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getAvailableFunds();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getPendingFunds();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getOwnerEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAddress();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.concierge_billing_publisher.BillingPublisherAddress.serializeBinaryToWriter
    );
  }
  f = message.getPaymentSettingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.concierge_billing_publisher.BillingPublisherPayoutSettings.serializeBinaryToWriter
    );
  }
  f = message.getInWithdrawalFunds();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getWebsiteLimit();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.concierge_billing_publisher.BillingPublisherResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherResponse} returns this
 */
proto.concierge_billing_publisher.BillingPublisherResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional double available_funds = 2;
 * @return {number}
 */
proto.concierge_billing_publisher.BillingPublisherResponse.prototype.getAvailableFunds = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherResponse} returns this
 */
proto.concierge_billing_publisher.BillingPublisherResponse.prototype.setAvailableFunds = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double pending_funds = 3;
 * @return {number}
 */
proto.concierge_billing_publisher.BillingPublisherResponse.prototype.getPendingFunds = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherResponse} returns this
 */
proto.concierge_billing_publisher.BillingPublisherResponse.prototype.setPendingFunds = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional string owner_email = 4;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherResponse.prototype.getOwnerEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherResponse} returns this
 */
proto.concierge_billing_publisher.BillingPublisherResponse.prototype.setOwnerEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional BillingPublisherAddress address = 5;
 * @return {?proto.concierge_billing_publisher.BillingPublisherAddress}
 */
proto.concierge_billing_publisher.BillingPublisherResponse.prototype.getAddress = function() {
  return /** @type{?proto.concierge_billing_publisher.BillingPublisherAddress} */ (
    jspb.Message.getWrapperField(this, proto.concierge_billing_publisher.BillingPublisherAddress, 5));
};


/**
 * @param {?proto.concierge_billing_publisher.BillingPublisherAddress|undefined} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherResponse} returns this
*/
proto.concierge_billing_publisher.BillingPublisherResponse.prototype.setAddress = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.concierge_billing_publisher.BillingPublisherResponse} returns this
 */
proto.concierge_billing_publisher.BillingPublisherResponse.prototype.clearAddress = function() {
  return this.setAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.concierge_billing_publisher.BillingPublisherResponse.prototype.hasAddress = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated BillingPublisherPayoutSettings payment_settings = 6;
 * @return {!Array<!proto.concierge_billing_publisher.BillingPublisherPayoutSettings>}
 */
proto.concierge_billing_publisher.BillingPublisherResponse.prototype.getPaymentSettingsList = function() {
  return /** @type{!Array<!proto.concierge_billing_publisher.BillingPublisherPayoutSettings>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_billing_publisher.BillingPublisherPayoutSettings, 6));
};


/**
 * @param {!Array<!proto.concierge_billing_publisher.BillingPublisherPayoutSettings>} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherResponse} returns this
*/
proto.concierge_billing_publisher.BillingPublisherResponse.prototype.setPaymentSettingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.concierge_billing_publisher.BillingPublisherPayoutSettings=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutSettings}
 */
proto.concierge_billing_publisher.BillingPublisherResponse.prototype.addPaymentSettings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.concierge_billing_publisher.BillingPublisherPayoutSettings, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_billing_publisher.BillingPublisherResponse} returns this
 */
proto.concierge_billing_publisher.BillingPublisherResponse.prototype.clearPaymentSettingsList = function() {
  return this.setPaymentSettingsList([]);
};


/**
 * optional double in_withdrawal_funds = 7;
 * @return {number}
 */
proto.concierge_billing_publisher.BillingPublisherResponse.prototype.getInWithdrawalFunds = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherResponse} returns this
 */
proto.concierge_billing_publisher.BillingPublisherResponse.prototype.setInWithdrawalFunds = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional int32 website_limit = 8;
 * @return {number}
 */
proto.concierge_billing_publisher.BillingPublisherResponse.prototype.getWebsiteLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherResponse} returns this
 */
proto.concierge_billing_publisher.BillingPublisherResponse.prototype.setWebsiteLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettings.oneofGroups_ = [[2,3,4,5]];

/**
 * @enum {number}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettings.SettingsCase = {
  SETTINGS_NOT_SET: 0,
  PAY_PAL: 2,
  MANUAL: 3,
  BANK_ACCOUNT: 4,
  WISE_ACCOUNT: 5
};

/**
 * @return {proto.concierge_billing_publisher.BillingPublisherPayoutSettings.SettingsCase}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettings.prototype.getSettingsCase = function() {
  return /** @type {proto.concierge_billing_publisher.BillingPublisherPayoutSettings.SettingsCase} */(jspb.Message.computeOneofCase(this, proto.concierge_billing_publisher.BillingPublisherPayoutSettings.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing_publisher.BillingPublisherPayoutSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing_publisher.BillingPublisherPayoutSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
paymentMethod: jspb.Message.getFieldWithDefault(msg, 1, 0),
payPal: (f = msg.getPayPal()) && proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings.toObject(includeInstance, f),
manual: (f = msg.getManual()) && proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings.toObject(includeInstance, f),
bankAccount: (f = msg.getBankAccount()) && proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.toObject(includeInstance, f),
wiseAccount: (f = msg.getWiseAccount()) && proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutSettings}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing_publisher.BillingPublisherPayoutSettings;
  return proto.concierge_billing_publisher.BillingPublisherPayoutSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing_publisher.BillingPublisherPayoutSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutSettings}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.common.BillingPublisherPaymentMethod} */ (reader.readEnum());
      msg.setPaymentMethod(value);
      break;
    case 2:
      var value = new proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings;
      reader.readMessage(value,proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings.deserializeBinaryFromReader);
      msg.setPayPal(value);
      break;
    case 3:
      var value = new proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings;
      reader.readMessage(value,proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings.deserializeBinaryFromReader);
      msg.setManual(value);
      break;
    case 4:
      var value = new proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings;
      reader.readMessage(value,proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.deserializeBinaryFromReader);
      msg.setBankAccount(value);
      break;
    case 5:
      var value = new proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings;
      reader.readMessage(value,proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings.deserializeBinaryFromReader);
      msg.setWiseAccount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing_publisher.BillingPublisherPayoutSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing_publisher.BillingPublisherPayoutSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getPayPal();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings.serializeBinaryToWriter
    );
  }
  f = message.getManual();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings.serializeBinaryToWriter
    );
  }
  f = message.getBankAccount();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.serializeBinaryToWriter
    );
  }
  f = message.getWiseAccount();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings.serializeBinaryToWriter
    );
  }
};


/**
 * optional common.BillingPublisherPaymentMethod payment_method = 1;
 * @return {!proto.common.BillingPublisherPaymentMethod}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettings.prototype.getPaymentMethod = function() {
  return /** @type {!proto.common.BillingPublisherPaymentMethod} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.common.BillingPublisherPaymentMethod} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettings.prototype.setPaymentMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional BillingPublisherPaymentPayPalSettings pay_pal = 2;
 * @return {?proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettings.prototype.getPayPal = function() {
  return /** @type{?proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings} */ (
    jspb.Message.getWrapperField(this, proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings, 2));
};


/**
 * @param {?proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings|undefined} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutSettings} returns this
*/
proto.concierge_billing_publisher.BillingPublisherPayoutSettings.prototype.setPayPal = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.concierge_billing_publisher.BillingPublisherPayoutSettings.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettings.prototype.clearPayPal = function() {
  return this.setPayPal(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettings.prototype.hasPayPal = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional BillingPublisherPaymentManualSettings manual = 3;
 * @return {?proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettings.prototype.getManual = function() {
  return /** @type{?proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings} */ (
    jspb.Message.getWrapperField(this, proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings, 3));
};


/**
 * @param {?proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings|undefined} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutSettings} returns this
*/
proto.concierge_billing_publisher.BillingPublisherPayoutSettings.prototype.setManual = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.concierge_billing_publisher.BillingPublisherPayoutSettings.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettings.prototype.clearManual = function() {
  return this.setManual(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettings.prototype.hasManual = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional BillingPublisherPaymentBankAccountSettings bank_account = 4;
 * @return {?proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettings.prototype.getBankAccount = function() {
  return /** @type{?proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings} */ (
    jspb.Message.getWrapperField(this, proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings, 4));
};


/**
 * @param {?proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings|undefined} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutSettings} returns this
*/
proto.concierge_billing_publisher.BillingPublisherPayoutSettings.prototype.setBankAccount = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.concierge_billing_publisher.BillingPublisherPayoutSettings.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettings.prototype.clearBankAccount = function() {
  return this.setBankAccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettings.prototype.hasBankAccount = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional BillingPublisherPaymentWiseAccountSettings wise_account = 5;
 * @return {?proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettings.prototype.getWiseAccount = function() {
  return /** @type{?proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings} */ (
    jspb.Message.getWrapperField(this, proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings, 5));
};


/**
 * @param {?proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings|undefined} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutSettings} returns this
*/
proto.concierge_billing_publisher.BillingPublisherPayoutSettings.prototype.setWiseAccount = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.concierge_billing_publisher.BillingPublisherPayoutSettings.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettings.prototype.clearWiseAccount = function() {
  return this.setWiseAccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettings.prototype.hasWiseAccount = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutVerificationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing_publisher.BillingPublisherPayoutVerificationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing_publisher.BillingPublisherPayoutVerificationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherPayoutVerificationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
paymentMethod: jspb.Message.getFieldWithDefault(msg, 1, 0),
verificationCode: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutVerificationRequest}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutVerificationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing_publisher.BillingPublisherPayoutVerificationRequest;
  return proto.concierge_billing_publisher.BillingPublisherPayoutVerificationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing_publisher.BillingPublisherPayoutVerificationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutVerificationRequest}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutVerificationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.common.BillingPublisherPaymentMethod} */ (reader.readEnum());
      msg.setPaymentMethod(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVerificationCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutVerificationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing_publisher.BillingPublisherPayoutVerificationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing_publisher.BillingPublisherPayoutVerificationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherPayoutVerificationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getVerificationCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional common.BillingPublisherPaymentMethod payment_method = 1;
 * @return {!proto.common.BillingPublisherPaymentMethod}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutVerificationRequest.prototype.getPaymentMethod = function() {
  return /** @type {!proto.common.BillingPublisherPaymentMethod} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.common.BillingPublisherPaymentMethod} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutVerificationRequest} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPayoutVerificationRequest.prototype.setPaymentMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string verification_code = 2;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutVerificationRequest.prototype.getVerificationCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutVerificationRequest} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPayoutVerificationRequest.prototype.setVerificationCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRemovingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing_publisher.BillingPublisherPayoutRemovingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing_publisher.BillingPublisherPayoutRemovingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRemovingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
paymentMethod: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutRemovingRequest}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRemovingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing_publisher.BillingPublisherPayoutRemovingRequest;
  return proto.concierge_billing_publisher.BillingPublisherPayoutRemovingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing_publisher.BillingPublisherPayoutRemovingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutRemovingRequest}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRemovingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.common.BillingPublisherPaymentMethod} */ (reader.readEnum());
      msg.setPaymentMethod(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRemovingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing_publisher.BillingPublisherPayoutRemovingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing_publisher.BillingPublisherPayoutRemovingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRemovingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional common.BillingPublisherPaymentMethod payment_method = 1;
 * @return {!proto.common.BillingPublisherPaymentMethod}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRemovingRequest.prototype.getPaymentMethod = function() {
  return /** @type {!proto.common.BillingPublisherPaymentMethod} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.common.BillingPublisherPaymentMethod} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutRemovingRequest} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPayoutRemovingRequest.prototype.setPaymentMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
email: jspb.Message.getFieldWithDefault(msg, 1, ""),
active: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
ownerId: jspb.Message.getFieldWithDefault(msg, 3, 0),
createdAt: jspb.Message.getFieldWithDefault(msg, 4, 0),
transferMethodCountry: jspb.Message.getFieldWithDefault(msg, 5, ""),
transferMethodCurrency: jspb.Message.getFieldWithDefault(msg, 6, ""),
status: jspb.Message.getFieldWithDefault(msg, 7, ""),
confirmed: jspb.Message.getBooleanFieldWithDefault(msg, 8, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings;
  return proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOwnerId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransferMethodCountry(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransferMethodCurrency(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setConfirmed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getOwnerId();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getTransferMethodCountry();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTransferMethodCurrency();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getConfirmed();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * optional string email = 1;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool active = 2;
 * @return {boolean}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional int64 owner_id = 3;
 * @return {number}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings.prototype.getOwnerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings.prototype.setOwnerId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 created_at = 4;
 * @return {number}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string transfer_method_country = 5;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings.prototype.getTransferMethodCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings.prototype.setTransferMethodCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string transfer_method_currency = 6;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings.prototype.getTransferMethodCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings.prototype.setTransferMethodCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string status = 7;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool confirmed = 8;
 * @return {boolean}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings.prototype.getConfirmed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPaymentPayPalSettings.prototype.setConfirmed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
description: jspb.Message.getFieldWithDefault(msg, 1, ""),
ownerId: jspb.Message.getFieldWithDefault(msg, 3, 0),
createdAt: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings;
  return proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOwnerId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOwnerId();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional string description = 1;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 owner_id = 3;
 * @return {number}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings.prototype.getOwnerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings.prototype.setOwnerId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 created_at = 4;
 * @return {number}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPaymentManualSettings.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
recipientId: jspb.Message.getFieldWithDefault(msg, 1, ""),
currency: jspb.Message.getFieldWithDefault(msg, 2, ""),
accountHolderName: jspb.Message.getFieldWithDefault(msg, 3, ""),
type: jspb.Message.getFieldWithDefault(msg, 4, ""),
details: (f = msg.getDetails()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
bankName: jspb.Message.getFieldWithDefault(msg, 6, ""),
status: jspb.Message.getFieldWithDefault(msg, 7, ""),
confirmed: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
createdAt: jspb.Message.getFieldWithDefault(msg, 9, 0),
accountSummary: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings;
  return proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecipientId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountHolderName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 5:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setDetails(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBankName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setConfirmed(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecipientId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAccountHolderName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDetails();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
  f = message.getBankName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getConfirmed();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getAccountSummary();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional string recipient_id = 1;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.prototype.getRecipientId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.prototype.setRecipientId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string currency = 2;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string account_holder_name = 3;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.prototype.getAccountHolderName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.prototype.setAccountHolderName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string type = 4;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.Struct details = 5;
 * @return {?proto.google.protobuf.Struct}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.prototype.getDetails = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 5));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings} returns this
*/
proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.prototype.setDetails = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.prototype.clearDetails = function() {
  return this.setDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.prototype.hasDetails = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string bank_name = 6;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.prototype.getBankName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.prototype.setBankName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string status = 7;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool confirmed = 8;
 * @return {boolean}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.prototype.getConfirmed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.prototype.setConfirmed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional int64 created_at = 9;
 * @return {number}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string account_summary = 10;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.prototype.getAccountSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPaymentBankAccountSettings.prototype.setAccountSummary = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
recipientId: jspb.Message.getFieldWithDefault(msg, 1, ""),
email: jspb.Message.getFieldWithDefault(msg, 2, ""),
accountHolderName: jspb.Message.getFieldWithDefault(msg, 3, ""),
status: jspb.Message.getFieldWithDefault(msg, 4, ""),
confirmed: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
createdAt: jspb.Message.getFieldWithDefault(msg, 6, 0),
accountSummary: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings;
  return proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecipientId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountHolderName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setConfirmed(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecipientId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAccountHolderName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getConfirmed();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getAccountSummary();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string recipient_id = 1;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings.prototype.getRecipientId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings.prototype.setRecipientId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string account_holder_name = 3;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings.prototype.getAccountHolderName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings.prototype.setAccountHolderName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string status = 4;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool confirmed = 5;
 * @return {boolean}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings.prototype.getConfirmed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings.prototype.setConfirmed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional int64 created_at = 6;
 * @return {number}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string account_summary = 7;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings.prototype.getAccountSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPaymentWiseAccountSettings.prototype.setAccountSummary = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing_publisher.BillingPublisherAddress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing_publisher.BillingPublisherAddress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherAddress.toObject = function(includeInstance, msg) {
  var f, obj = {
addressId: jspb.Message.getFieldWithDefault(msg, 1, 0),
companyName: jspb.Message.getFieldWithDefault(msg, 2, ""),
firstLine: jspb.Message.getFieldWithDefault(msg, 3, ""),
secondLine: jspb.Message.getFieldWithDefault(msg, 4, ""),
city: jspb.Message.getFieldWithDefault(msg, 5, ""),
zipCode: jspb.Message.getFieldWithDefault(msg, 6, ""),
state: jspb.Message.getFieldWithDefault(msg, 7, ""),
country: jspb.Message.getFieldWithDefault(msg, 8, ""),
contactEmail: jspb.Message.getFieldWithDefault(msg, 9, ""),
contactName: jspb.Message.getFieldWithDefault(msg, 10, ""),
tax: jspb.Message.getFieldWithDefault(msg, 11, ""),
dateOfBirth: jspb.Message.getFieldWithDefault(msg, 12, 0),
payoutProfileType: jspb.Message.getFieldWithDefault(msg, 13, 0),
foreignTin: jspb.Message.getFieldWithDefault(msg, 14, ""),
usTin: jspb.Message.getFieldWithDefault(msg, 15, ""),
countryOfTaxResidence: jspb.Message.getFieldWithDefault(msg, 16, ""),
countryOfCitizenship: jspb.Message.getFieldWithDefault(msg, 17, ""),
countryOfIncorporation: jspb.Message.getFieldWithDefault(msg, 18, ""),
entityClassification: jspb.Message.getFieldWithDefault(msg, 19, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing_publisher.BillingPublisherAddress}
 */
proto.concierge_billing_publisher.BillingPublisherAddress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing_publisher.BillingPublisherAddress;
  return proto.concierge_billing_publisher.BillingPublisherAddress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing_publisher.BillingPublisherAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing_publisher.BillingPublisherAddress}
 */
proto.concierge_billing_publisher.BillingPublisherAddress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAddressId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstLine(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecondLine(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setZipCode(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setState(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setContactEmail(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setContactName(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setTax(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDateOfBirth(value);
      break;
    case 13:
      var value = /** @type {!proto.common.BillingPublisherPayoutProfileType} */ (reader.readEnum());
      msg.setPayoutProfileType(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setForeignTin(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsTin(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryOfTaxResidence(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryOfCitizenship(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryOfIncorporation(value);
      break;
    case 19:
      var value = /** @type {!proto.common.BillingEntityClassification} */ (reader.readEnum());
      msg.setEntityClassification(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing_publisher.BillingPublisherAddress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing_publisher.BillingPublisherAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherAddress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddressId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getCompanyName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFirstLine();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSecondLine();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getZipCode();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getState();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getContactEmail();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getContactName();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getTax();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getDateOfBirth();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getPayoutProfileType();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getForeignTin();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getUsTin();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getCountryOfTaxResidence();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getCountryOfCitizenship();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getCountryOfIncorporation();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getEntityClassification();
  if (f !== 0.0) {
    writer.writeEnum(
      19,
      f
    );
  }
};


/**
 * optional int64 address_id = 1;
 * @return {number}
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.getAddressId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherAddress} returns this
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.setAddressId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string company_name = 2;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.getCompanyName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherAddress} returns this
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.setCompanyName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string first_line = 3;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.getFirstLine = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherAddress} returns this
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.setFirstLine = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string second_line = 4;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.getSecondLine = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherAddress} returns this
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.setSecondLine = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string city = 5;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherAddress} returns this
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string zip_code = 6;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.getZipCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherAddress} returns this
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.setZipCode = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string state = 7;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.getState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherAddress} returns this
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.setState = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string country = 8;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherAddress} returns this
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string contact_email = 9;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.getContactEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherAddress} returns this
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.setContactEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string contact_name = 10;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.getContactName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherAddress} returns this
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.setContactName = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string tax = 11;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.getTax = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherAddress} returns this
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.setTax = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional int64 date_of_birth = 12;
 * @return {number}
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.getDateOfBirth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherAddress} returns this
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.setDateOfBirth = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional common.BillingPublisherPayoutProfileType payout_profile_type = 13;
 * @return {!proto.common.BillingPublisherPayoutProfileType}
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.getPayoutProfileType = function() {
  return /** @type {!proto.common.BillingPublisherPayoutProfileType} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.common.BillingPublisherPayoutProfileType} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherAddress} returns this
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.setPayoutProfileType = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional string foreign_tin = 14;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.getForeignTin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherAddress} returns this
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.setForeignTin = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string us_tin = 15;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.getUsTin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherAddress} returns this
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.setUsTin = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string country_of_tax_residence = 16;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.getCountryOfTaxResidence = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherAddress} returns this
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.setCountryOfTaxResidence = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string country_of_citizenship = 17;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.getCountryOfCitizenship = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherAddress} returns this
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.setCountryOfCitizenship = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string country_of_incorporation = 18;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.getCountryOfIncorporation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherAddress} returns this
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.setCountryOfIncorporation = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional common.BillingEntityClassification entity_classification = 19;
 * @return {!proto.common.BillingEntityClassification}
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.getEntityClassification = function() {
  return /** @type {!proto.common.BillingEntityClassification} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {!proto.common.BillingEntityClassification} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherAddress} returns this
 */
proto.concierge_billing_publisher.BillingPublisherAddress.prototype.setEntityClassification = function(value) {
  return jspb.Message.setProto3EnumField(this, 19, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing_publisher.BillingPublisherWithdrawalRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing_publisher.BillingPublisherWithdrawalRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing_publisher.BillingPublisherWithdrawalRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherWithdrawalRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
amount: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
paymentMethod: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing_publisher.BillingPublisherWithdrawalRequest}
 */
proto.concierge_billing_publisher.BillingPublisherWithdrawalRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing_publisher.BillingPublisherWithdrawalRequest;
  return proto.concierge_billing_publisher.BillingPublisherWithdrawalRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing_publisher.BillingPublisherWithdrawalRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing_publisher.BillingPublisherWithdrawalRequest}
 */
proto.concierge_billing_publisher.BillingPublisherWithdrawalRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAmount(value);
      break;
    case 2:
      var value = /** @type {!proto.common.BillingPublisherPaymentMethod} */ (reader.readEnum());
      msg.setPaymentMethod(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing_publisher.BillingPublisherWithdrawalRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing_publisher.BillingPublisherWithdrawalRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing_publisher.BillingPublisherWithdrawalRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherWithdrawalRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getPaymentMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional double amount = 1;
 * @return {number}
 */
proto.concierge_billing_publisher.BillingPublisherWithdrawalRequest.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherWithdrawalRequest} returns this
 */
proto.concierge_billing_publisher.BillingPublisherWithdrawalRequest.prototype.setAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional common.BillingPublisherPaymentMethod payment_method = 2;
 * @return {!proto.common.BillingPublisherPaymentMethod}
 */
proto.concierge_billing_publisher.BillingPublisherWithdrawalRequest.prototype.getPaymentMethod = function() {
  return /** @type {!proto.common.BillingPublisherPaymentMethod} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.common.BillingPublisherPaymentMethod} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherWithdrawalRequest} returns this
 */
proto.concierge_billing_publisher.BillingPublisherWithdrawalRequest.prototype.setPaymentMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
isSuccess: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
optionalTransactionId: jspb.Message.getFieldWithDefault(msg, 3, ""),
optionalTransactionCost: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
state: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse}
 */
proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse;
  return proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse}
 */
proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOptionalTransactionId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setOptionalTransactionCost(value);
      break;
    case 5:
      var value = /** @type {!proto.common.BillingPublisherWithdrawalRequestState} */ (reader.readEnum());
      msg.setState(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOptionalTransactionId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOptionalTransactionCost();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional bool is_success = 1;
 * @return {boolean}
 */
proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse.prototype.getIsSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse} returns this
 */
proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse.prototype.setIsSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse} returns this
 */
proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string optional_transaction_id = 3;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse.prototype.getOptionalTransactionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse} returns this
 */
proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse.prototype.setOptionalTransactionId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional double optional_transaction_cost = 4;
 * @return {number}
 */
proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse.prototype.getOptionalTransactionCost = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse} returns this
 */
proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse.prototype.setOptionalTransactionCost = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional common.BillingPublisherWithdrawalRequestState state = 5;
 * @return {!proto.common.BillingPublisherWithdrawalRequestState}
 */
proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse.prototype.getState = function() {
  return /** @type {!proto.common.BillingPublisherWithdrawalRequestState} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.common.BillingPublisherWithdrawalRequestState} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse} returns this
 */
proto.concierge_billing_publisher.BillingPublisherWithdrawalResponse.prototype.setState = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
isSuccess: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
fieldErrorsList: jspb.Message.toObjectList(msg.getFieldErrorsList(),
    proto.concierge_billing_publisher.PayoutFieldError.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse;
  return proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = new proto.concierge_billing_publisher.PayoutFieldError;
      reader.readMessage(value,proto.concierge_billing_publisher.PayoutFieldError.deserializeBinaryFromReader);
      msg.addFieldErrors(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFieldErrorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.concierge_billing_publisher.PayoutFieldError.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool is_success = 1;
 * @return {boolean}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse.prototype.getIsSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse.prototype.setIsSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated PayoutFieldError field_errors = 3;
 * @return {!Array<!proto.concierge_billing_publisher.PayoutFieldError>}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse.prototype.getFieldErrorsList = function() {
  return /** @type{!Array<!proto.concierge_billing_publisher.PayoutFieldError>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.concierge_billing_publisher.PayoutFieldError, 3));
};


/**
 * @param {!Array<!proto.concierge_billing_publisher.PayoutFieldError>} value
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse} returns this
*/
proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse.prototype.setFieldErrorsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.concierge_billing_publisher.PayoutFieldError=} opt_value
 * @param {number=} opt_index
 * @return {!proto.concierge_billing_publisher.PayoutFieldError}
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse.prototype.addFieldErrors = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.concierge_billing_publisher.PayoutFieldError, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse} returns this
 */
proto.concierge_billing_publisher.BillingPublisherPayoutSettingsResponse.prototype.clearFieldErrorsList = function() {
  return this.setFieldErrorsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.concierge_billing_publisher.PayoutFieldError.prototype.toObject = function(opt_includeInstance) {
  return proto.concierge_billing_publisher.PayoutFieldError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.concierge_billing_publisher.PayoutFieldError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.PayoutFieldError.toObject = function(includeInstance, msg) {
  var f, obj = {
field: jspb.Message.getFieldWithDefault(msg, 1, ""),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
code: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.concierge_billing_publisher.PayoutFieldError}
 */
proto.concierge_billing_publisher.PayoutFieldError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.concierge_billing_publisher.PayoutFieldError;
  return proto.concierge_billing_publisher.PayoutFieldError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.concierge_billing_publisher.PayoutFieldError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.concierge_billing_publisher.PayoutFieldError}
 */
proto.concierge_billing_publisher.PayoutFieldError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setField(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.concierge_billing_publisher.PayoutFieldError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.concierge_billing_publisher.PayoutFieldError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.concierge_billing_publisher.PayoutFieldError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.concierge_billing_publisher.PayoutFieldError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getField();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string field = 1;
 * @return {string}
 */
proto.concierge_billing_publisher.PayoutFieldError.prototype.getField = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.PayoutFieldError} returns this
 */
proto.concierge_billing_publisher.PayoutFieldError.prototype.setField = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.concierge_billing_publisher.PayoutFieldError.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.PayoutFieldError} returns this
 */
proto.concierge_billing_publisher.PayoutFieldError.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string code = 3;
 * @return {string}
 */
proto.concierge_billing_publisher.PayoutFieldError.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.concierge_billing_publisher.PayoutFieldError} returns this
 */
proto.concierge_billing_publisher.PayoutFieldError.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


goog.object.extend(exports, proto.concierge_billing_publisher);
